export const errorHandler = (response: any) => {
  if (response['error']['code'] == 403) {
    localStorage.clear();
    window.location.href = '/auth/login';
  }
};
